module.exports = __webpack_public_path__ + "static/media/section-header-2.9368ecde.jpg";